<!-- Modern Filter Section -->
<section class="filter-modern-container">
  <div class="filter-modern-backdrop">
    <div class="filter-modern-content">
      <div class="container px-lg-4 px-md-3 px-2">
        <form [formGroup]="filter_form" class="filter-modern-form">

          <!-- Modern Header -->
          <div class="filter-modern-header">
            <div class="filter-modern-title-section">
              <h2 class="filter-modern-title">
                <i class="fas fa-search filter-modern-title-icon"></i>
                {{ "Explore top companies hiring now" | translate }}
              </h2>
              <p class="filter-modern-subtitle" style="text-align: center;">
                {{ "Find your perfect job opportunity with our advanced filters" | translate }}
              </p>
            </div>
          </div>

          <!-- Modern Filter Card Container -->
          <div class="filter-modern-card-container">
            <div class="filter-modern-grid">

              <!-- Industry Filter -->
              <div class="filter-modern-field-group">
                <label class="filter-modern-label">{{ "Search by Industry" | translate }}</label>
                <div class="filter-modern-field">
                  <tm-select [options]="masters.industriesMaster || []" [form_group]="filter_form" [design_pattern]="2"
                    form_control="industryId" [appearance]="'outline'" title_property="title" id_property="id"
                    [title]="'Industry' | translate" float_label="always" [data]="filter_form.value.industryId"
                    [placeholder]="'Industry' | translate" class="filter-modern-select">
                  </tm-select>
                </div>
              </div>

              <!-- Keywords Filter -->
              <div class="filter-modern-field-group">
                <label class="filter-modern-label">{{ "Search by keyword" | translate }}</label>
                <div class="filter-modern-field">
                  <input type="search" class="filter-modern-input" id="search"
                    [placeholder]="'IJP.enter_keywords' | translate" formControlName="search" autocomplete="off" />
                </div>
              </div>

              <!-- Experience Filter -->
              <div class="filter-modern-field-group">
                <label class="filter-modern-label">{{ "Search by Experience" | translate }}</label>
                <div class="filter-modern-field">
                  <input type="number" class="filter-modern-input" id="expTo" formControlName="expTo"
                    [placeholder]="'Years of experience' | translate" min="0" max="50" />
                </div>
              </div>

              <!-- Location Filter -->
              <div class="filter-modern-field-group location-field">
                <label class="filter-modern-label">{{ "Search by Locations" | translate }}</label>
                <div class="filter-modern-field">
                  <tm-multi-select [options]="masters.locationList || []" [form_group]="filter_form"
                    form_control="location" [design_pattern]="2" [appearance]="'outline'" title_property="title"
                    id_property="id" float_label="always" [data]="filter_form.value.location"
                    [placeholder]="'IJP.Select Locations' | translate" class="filter-modern-select">
                  </tm-multi-select>
                </div>
              </div>

            </div>

            <!-- Action Buttons - Centered Below Fields -->
            <div class="filter-modern-actions">
              <button type="button" class="filter-modern-btn filter-modern-btn-primary" (click)="JobsList()"
                [disabled]="filter_form.invalid">
                <i class="fas fa-search"></i>
                <span>{{ "Search" | translate }}</span>
              </button>

              <button type="button" class="filter-modern-btn filter-modern-btn-secondary" (click)="reset()">
                <i class="fas fa-undo-alt"></i>
                <span>{{ "BTN.reset" | translate }}</span>
              </button>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<div class="container py-3">
  <div class="row g-3 gx-3 gy-3">
    <div class="col-12 col-md-6" *ngFor="let job of jobs; let index = index">
      <div class="horizontal-job-card" [class.applied]="job.applied">

        <!-- Card Header with Job Title and Actions -->
        <div class="card-header-compact">
          <div class="title-section">
            <h6 class="job-title" style="text-transform: capitalize;" (click)="openNewTabs(job)">{{ job.productName }}
            </h6>
            <span class="job-code">{{ job.productCodeText }}</span>
          </div>
          <div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <button (click)="socialMediaShare(job)"
                style="background: none; border: none; color: #64748b; cursor: pointer; padding: 6px; border-radius: 6px; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px;"
                onmouseover="this.style.background='#f1f5f9'; this.style.color='#374151'"
                onmouseout="this.style.background='none'; this.style.color='#64748b'">
                <i class="fas fa-share-alt" style="font-size: 13px;" [ngStyle]="{'color': '#64748b'}"></i>
                <!-- <span style="font-size: 11px; font-weight: 500;">{{ "Share" | translate }}</span> -->
              </button>
            </div>
          </div>
        </div>

        <!-- Horizontal Details Layout -->
        <div class="details-horizontal">

          <!-- Row 1: Experience & Notice Period -->
          <div class="detail-row-compact"
            *ngIf="this.field_config_access && this.field_config_access['CAREERS_dataJobLocations']">
            <div class="detail-item-compact">
              <div class="icon-soft experience-soft">
                <i class="fas fa-user-tie"></i>
              </div>
              <div class="content-compact">
                <div class="value-compact" [title]="getExperienceTitle(job)">
                  <ng-container *ngIf="job.expTo > 0">{{ job.expTo > 0 ? job.expFrom : ("IJP.Fresher" | translate)
                    }}</ng-container>
                  <ng-container *ngIf="job.expTo == 0"> {{ "IJP.Fresher" | translate }}</ng-container>
                  <ng-container *ngIf="job.expTo && job.expTo > 0"> - {{ job.expTo }}</ng-container>
                  <ng-container *ngIf="job.expTo > 0 || job.expFrom > 0">
                    {{ job.expTo > 1 ? ("IJP.years" | translate) : ("IJP.year" | translate) }}
                  </ng-container>
                </div>
                <div class="label-compact">Experience</div>
              </div>
            </div>
            <div class="detail-item-compact">
              <div class="icon-soft notice-soft">
                <i class="fas fa-clock"></i>
              </div>
              <div class="content-compact">
                <div class="value-compact" [title]="getNoticePeriodTitle(job)">
                  <ng-container *ngIf="job.noticePeriodTo > 0">{{ job.noticePeriodTo > 0 ? job.noticePeriodFrom :
                    ("IJP.Immediate" | translate) }}</ng-container>
                  <ng-container *ngIf="job.noticePeriodTo && job.noticePeriodTo > 0"> - {{ job.noticePeriodTo
                    }}</ng-container>
                  <ng-container *ngIf="job.noticePeriodTo > 1"> {{ "IJP.days" | translate }}</ng-container>
                  <ng-container *ngIf="job.noticePeriodTo == 0"> {{ "IJP.Immediate" | translate }}</ng-container>
                </div>
                <div class="label-compact">Notice Period</div>
              </div>
            </div>
          </div>

          <!-- Row 2: Location & Job Type -->
          <div class="detail-row-compact">
            <div class="detail-item-compact">
              <div class="icon-soft location-soft">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <div class="content-compact">
                <div class="value-compact location-value" [title]="getLocationTitle(job)">
                  {{ job.jobLocation != "" ? job.jobLocation : ("IJP.Not Mentioned" | translate) }}
                </div>
                <div class="label-compact">Location</div>
              </div>
            </div>
            <div class="detail-item-compact"
              *ngIf="this.field_config_access && this.field_config_access['CAREERS_dataJobType']">
              <div class="icon-soft jobtype-soft">
                <i class="fas fa-briefcase"></i>
              </div>
              <div class="content-compact">
                <div class="value-compact jobtype-value" [title]="getJobTypeTitle(job)">
                  {{ job.jobType != "" ? job.jobType : ("IJP.Not Mentioned" | translate) }}
                </div>
                <div class="label-compact">Job Type</div>
              </div>
            </div>
          </div>

          <!-- Row 3: Compensation & Skills -->
          <div class="detail-row-compact">
            <div class="detail-item-compact"
              *ngIf="this.field_config_access && this.field_config_access['CAREERS_dataCompensation']">
              <div class="icon-soft salary-soft">
                <i class="fas fa-rupee-sign"></i>
              </div>
              <div class="content-compact">
                <div class="value-compact compensation-value" [title]="getCompensationTitle(job)">
                  <ng-container *ngIf="job.expSalaryTo > 0 || job.expSalaryFrom > 0; else noMentioned">
                    {{ job.expSalaryCurrSymbol }}{{ job.expSalaryTo > 0 && job.expSalaryFrom > 0 ? job.expSalaryFrom :
                    ("IJP.Not Mentioned" | translate) }}
                    <span *ngIf="job.expSalaryTo && job.expSalaryTo > 0"> - {{ job.expSalaryTo }}</span>
                    <small class="duration">{{ job.expSalaryScaleDuration }}</small>
                  </ng-container>
                  <ng-template #noMentioned>{{ "IJP.Not Mentioned" | translate }}</ng-template>
                </div>
                <div class="label-compact">Compensation</div>
              </div>
            </div>
            <div class="detail-item-compact"
              *ngIf="this.field_config_access && this.field_config_access['CAREERS_keySkills'] && job.keySkills">
              <div class="icon-soft skills-soft">
                <i class="fas fa-cogs"></i>
              </div>
              <div class="content-compact" [title]="getSkillsTitle(job)">
                <div class="value-compact skills-value-compact" [title]="getSkillsTitle(job)">
                  {{ job.keySkills }}
                </div>
                <div class="label-compact">Key Skills</div>
              </div>
            </div>
          </div>

        </div>

        <!-- Compact Footer -->
        <div class="footer-horizontal">
          <div class="info-compact">
            <div class="posted-compact">
              <i class="fas fa-calendar-alt" style="margin-right: 5px; font-size: 10px;"></i>
              <span *ngIf="job.postedDate" style="font-size: 10px;">{{ job.postedDate | UtcToLocalTime | date :
                "d-MMM-yyyy h:mm a" }}</span>
              <span *ngIf="!job.postedDate" style="font-size: 10px;">No date</span>
            </div>
            <!-- <div class="applicants-compact" *ngIf="job.jobApplicants">
              <i class="fas fa-users"></i>
              <span>{{ job.jobApplicants }}</span>
            </div> -->
          </div>
          <div class="apply-compact">
            <button class="apply-btn-horizontal" [class.applied]="job.applied" [disabled]="job.applied"
              (click)="applyJob(job)">
              <i class="fas fa-check" *ngIf="job.applied"></i>
              <i class="fas fa-paper-plane" *ngIf="!job.applied"></i>
              {{ job.applied ? ('Applied' | translate) : ('Apply' | translate) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Enhanced Pagination -->
  <div class="pagination-section">
    <div class="pagination-wrapper">
      <div class="page-controls" *ngIf="this.jobs && jobs.length">
        <span class="control-label">Show:</span>
        <div class="size-controls">
          <button class="control-btn" [class.active]="limit == i.code" *ngFor="let i of limit_list; let index = index"
            (click)="getNextPage(null, i)">
            {{ i.title }}
          </button>
        </div>
      </div>
      <ngb-pagination *ngIf="total_count" class="enhanced-pagination" [collectionSize]="total_count"
        [(page)]="start_page" [maxSize]="3" [rotate]="true" (pageChange)="getNextPage($event, null)"
        [pageSize]="limit || 40">
      </ngb-pagination>
    </div>
  </div>
</div>